import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { DOCUMENT_STATUS_TONE } from '@/entity/components/content/components/document-item/utils/get-document-status';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import { CARD_STATUS_TEXT } from '../../../card-title';
import useDocumentSummary from './use-document-summary';
type DocumentDetailsProps = {
  document: TransformedDocument;
  className?: string;
};

/** A neutral status keeps the line's gray; only a warning or failed one gets its color. */
const DocumentDetails = t0 => {
  const $ = _c(13);
  const {
    document,
    className
  } = t0;
  const {
    details,
    status,
    statusText
  } = useDocumentSummary(document);
  const tone = status && DOCUMENT_STATUS_TONE[status];
  let t1;
  if ($[0] !== className) {
    t1 = cx("mt-0.5 text-body-3 text-tertiary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== details) {
    t2 = details.join(" \xB7 ");
    $[2] = details;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== details.length || $[5] !== status || $[6] !== statusText || $[7] !== tone) {
    t3 = status && <>{details.length > 0 && " \xB7 "}<span className={cx(tone && tone !== "neutral" && CARD_STATUS_TEXT[tone])}>{statusText}</span></>;
    $[4] = details.length;
    $[5] = status;
    $[6] = statusText;
    $[7] = tone;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <p className={t1}>{t2}{t3}</p>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default DocumentDetails;